import script from "./AdminProductListView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProductListView.vue?vue&type=script&setup=true&lang=js"

import "./AdminProductListView.vue?vue&type=style&index=0&id=414452a6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-414452a6"]])

export default __exports__